import React from 'react';
import PropTypes from 'prop-types';

import Style from './OnHoldAccount.module.scss';

const OnHoldAccount = ({ message }) => (
  <div className={Style.container}>
    <p className={Style.message}>{message}</p>
  </div>
);

OnHoldAccount.propTypes = {
  message: PropTypes.string,
};

export default OnHoldAccount;
